<div #mediaUpload>
    <ngx-dropzone [accept]="$acceptFormat()" [maxFileSize]="$maxSize()!" class="h-full" (change)="changeFile($event)">
        <ngx-dropzone-label>{{label}} ({{'Max size' | translate:{value: $maxSizeLabel()} }})</ngx-dropzone-label>
        @if ($currentFile()) {
            <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" [file]="$currentFile()!" [removable]="true"
                (removed)="deleted.emit()" class="h-full w-full">
            </ngx-dropzone-image-preview>
        }
    </ngx-dropzone>
</div>